import { Modal, MuniSpinner2, TextInput } from "../../../components"
import { useGeneralAppStore } from "../../../store/generalAppStore"
import { anularDenuncia, aprobarDenuncia } from "../ModalInfraccionMCD/components/Formularios/handlers";
import { Button } from "react-bootstrap";

const ModalAnularDenuncia = (props) => {

    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { infraccion_seleccionada, datosTitular, setInfraccionesNuevas } = props;

    return (
        <>
            <Modal
                show={modals.includes('anular_denuncia')}
                size={'md'}
                onHide={() => { handlerModal({ modal: false, modalName: "anular_denuncia" }) }}
                // backdrop={'static'}


                title={() => 'Anular denuncia'}
            >
                <section>
                    <h5 className="m-0">Desea anular la denuncia?</h5>
                    <hr />
                    <div className="d-flex justify-content-end gap-2">

                        <Button variant="danger" size="sm" onClick={() => { handlerModal({ modal: false, modalName: "anular_denuncia" }) }}>
                            Cancelar
                        </Button>
                        <Button size="sm" onClick={() => anularDenuncia({ id: infraccion_seleccionada?.id }, setInfraccionesNuevas)}>
                            Confirmar
                        </Button>
                    </div>
                </section>
            </Modal>
        </>
    )
}

export default ModalAnularDenuncia;